import PropTypes from 'prop-types'
import React, { forwardRef } from 'react'
import MultiSelectDropdownList from './MultiSelectDropdownList'
import useFilteredDropdownList from './useFilteredDropdownList'

/**
 * Create a React Filtered Multi Select Dropdown List
 *
 * @template T
 * @template Item
 * @param {import('./interfaces').FilteredMultiSelectDropdownListProps<T, Item>} props
 * @param {React.Ref<HTMLElement>} ref
 * @returns {JSX.Element}
 */
function filteredMultiSelectDropdownList (props, ref) {
  const filteredProps = useFilteredDropdownList(props, true)

  return <MultiSelectDropdownList {...props} {...filteredProps} ref={ref} />
}

/**
 * @template T
 * @template Item
 * @type {React.ForwardRefExoticComponent<import('./interfaces').FilteredMultiSelectDropdownListProps<T, Item> & React.RefAttributes<HTMLElement>>}
 */
const FilteredMultiSelectDropdownList = forwardRef(
  filteredMultiSelectDropdownList
)
FilteredMultiSelectDropdownList.displayName = 'FilteredMultiSelectDropdownList'
FilteredMultiSelectDropdownList.props = {
  ...MultiSelectDropdownList.props,
  getItemValue: PropTypes.func,
  filter: PropTypes.string
}
FilteredMultiSelectDropdownList.defaultProps = {
  ...MultiSelectDropdownList.defaultProps,
  getItemValue: String,
  filter: ''
}

export default FilteredMultiSelectDropdownList
